import type { App } from '@nab/x-types';
import { AbstractEventBus } from '@nab/x-events';
import { getAppMetaDataForInstanceId } from '../registries/instanceRegistry';

class RuntimeEventBus extends AbstractEventBus {
    protected getAppMetaDataForInstanceId(instanceId: string): App {
        return getAppMetaDataForInstanceId(instanceId);
    }
}

export const runtimeEventBus = new RuntimeEventBus();
